import { Col, Divider, Row, Typography } from "antd";
import React from "react";

type BankDetailItemProps = {
  label: string;
  value?: React.ReactNode;
  valueFallback?: React.ReactNode;
  labelStyle?: React.CSSProperties;
  withDivider?: boolean;
};

export const BankDetailItem = (props: BankDetailItemProps) => {
  const { label, value, valueFallback = "-", labelStyle, withDivider = true } = props;

  return (
    <>
      <Row style={{ padding: "1.5rem" }}>
        <Col span={10}>
          <Typography.Text style={{ color: "var(--blue-600)", ...labelStyle }} strong>
            {label}
          </Typography.Text>
        </Col>
        <Col flex="1">
          <Typography.Text>{value || valueFallback}</Typography.Text>
        </Col>
      </Row>
      {withDivider && <Divider />}
    </>
  );
};
